import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  const addToCart = (service) => {
    setCart(prev => {
      const exists = prev.find(i => i._id === service._id);
      if (exists) return prev;
      return [...prev, { ...service, quantity: 1 }];
    });
  };

  const removeFromCart = (id) => setCart(prev => prev.filter(i => i._id !== id));
  const clearCart      = () => setCart([]);
  const isInCart       = (id) => cart.some(i => i._id === id);

  // ── Per-item price helper ────────────────────────────────────────────
  // canUseTrial passed from CheckoutPage to compute per-item price
  const getItemPrice = (item, canUseTrial = false) => {
    if (canUseTrial && item.trialEligible) return 0;
    return (item.pricing?.discountedPrice || item.pricing?.basePrice || 0) * (item.quantity || 1);
  };

  // cartTotal — full price (no trial deduction here, done at checkout)
  const cartTotal = cart.reduce((sum, item) => {
    const price = item.pricing?.discountedPrice || item.pricing?.basePrice || 0;
    return sum + price * (item.quantity || 1);
  }, 0);

  // Paid total — only non-trial items (used when mixed cart)
  const getPaidTotal = (canUseTrial = false) =>
    cart.reduce((sum, item) => {
      if (canUseTrial && item.trialEligible) return sum;
      const price = item.pricing?.discountedPrice || item.pricing?.basePrice || 0;
      return sum + price * (item.quantity || 1);
    }, 0);

  const cartCount = cart.length;

  return (
    <CartContext.Provider value={{
      cart, addToCart, removeFromCart, clearCart,
      isInCart, cartTotal, cartCount,
      getItemPrice, getPaidTotal,
    }}>
      {children}
    </CartContext.Provider>
  );
}
